import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import { EmailSubscriptionDataKey } from '@/interfaces/user.interfaces';
import { EmailNotificationContainer } from './Notifications.styles';
import { NotificationItem } from './components/NotificationItem';

export const Notifications = () => {
  const { t, userInfo } = useGlobalState();

  const notificationList = [
    {
      // Shipment Summary
      dataKey: EmailSubscriptionDataKey.SubscribeToEmailSummary,
      title: t(MasterTranslation.AccNotificationsSummaryEmailTitle),
      subText: t(MasterTranslation.AccNotificationsSummaryEmailSubtitle),
      toggled: !!userInfo?.subscribeToEmailSummary,
      popupMainText: t(MasterTranslation.AccDialogParcelSummaryEmailsTitle),
      popupSubText: t(MasterTranslation.AccDialogParcelSummaryEmailsDescription),
      popupConfirmText: t(MasterTranslation.UnsubscribePopupButton),
    },
    {
      // Individual Parcel Emails
      dataKey: EmailSubscriptionDataKey.DefaultOptIn,
      title: t(MasterTranslation.AccNotificationsIndividualEmailTitle),
      subText: t(MasterTranslation.AccNotificationsIndividualEmailSubtitle),
      toggled: !!userInfo?.defaultOptIn,
      popupMainText: t(MasterTranslation.AccDialogIndividualParcelEmailsTitle),
      popupSubText: t(MasterTranslation.AccDialogIndividualParcelEmailsDescription),
      popupConfirmText: t(MasterTranslation.UnsubscribePopupButton),
    },
    {
      // Marketing Emails
      dataKey: EmailSubscriptionDataKey.NewsletterOptIn,
      title: t(MasterTranslation.AccNotificationsMarketingEmailTitle),
      subText: t(MasterTranslation.AccNotificationsMarketingEmailSubtitle),
      toggled: !!userInfo?.newsletterOptIn,
      popupMainText: t(MasterTranslation.AccDialogMarketingEmailsTitle),
      popupSubText: t(MasterTranslation.AccDialogMarketingEmailsDescription),
      popupConfirmText: t(MasterTranslation.UnsubscribePopupButton),
    },
  ];

  return (
    <EmailNotificationContainer>
      {notificationList.map((item) => (
        <NotificationItem
          key={item.dataKey}
          dataKey={item.dataKey}
          title={item.title}
          subText={item.subText}
          toggled={item.toggled}
          popupMainText={item.popupMainText}
          popupSubText={item.popupSubText}
          popupConfirmText={item.popupConfirmText}
        />
      ))}
    </EmailNotificationContainer>
  );
};
